import React, { ComponentProps } from "react";
import { grid2Classes, grid2Size, Grid2Variants } from "./Grid2.style";

type Size = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl";

type ResponsiveSize = Partial<Record<Breakpoint, Size>>;

export type Grid2Props = Grid2Variants &
  ResponsiveSize &
  ComponentProps<"div"> & {
    size?: Size | ResponsiveSize;
    item?: boolean;
    justifyContent?: Grid2Variants["align"];
  };

const Grid2 = (props: Grid2Props) => {
  const {
    className,
    container,
    spacing,
    rowSpacing,
    columnSpacing,
    size,
    direction,
    wrap,
    justify,
    justifyContent,
    align,
    item,
    xs,
    sm,
    md,
    lg,
    xl,
    ...rest
  } = props;

  const oldJustifySupport = align || justifyContent;

  if (container) {
    return (
      <div
        {...rest}
        className={grid2Classes({
          class: className,
          container,
          spacing,
          columnSpacing,
          rowSpacing,
          direction,
          wrap,
          justify,
          align: oldJustifySupport,
        })}
        style={
          { "--Grid-spacing": spacing || columnSpacing } as React.CSSProperties
        }
      />
    );
  }

  const responsive: ResponsiveSize = {
    ...((typeof size === "object" ? size : {}) as ResponsiveSize),
    ...(xs ? { xs } : {}),
    ...(sm ? { sm } : {}),
    ...(md ? { md } : {}),
    ...(lg ? { lg } : {}),
    ...(xl ? { xl } : {}),
  };

  const classes: string[] = [];

  // Base size if passed as number
  if (typeof size === "number") {
    classes.push(grid2Size({ size, class: className }));
  }

  // Handle responsive props manually
  for (const [key, val] of Object.entries(responsive)) {
    if (!val) continue;
    const prefix = key === "base" ? "" : `${key}:`;
    const sizeClass = grid2Size({ size: val, class: className });
    classes.push(`${prefix}${sizeClass}`);
  }

  return <div {...rest} className={[grid2Classes(), ...classes].join(" ")} />;
};
export default Grid2;
